import { useEffect, useState } from 'react';

/**
 * Resolves a player's signature-sound id to its manifest clip, so avatars can
 * be drawn from the real waveform. Cached module-level: one fetch per page.
 */
let manifestPromise = null;
function loadClips() {
  if (!manifestPromise) {
    manifestPromise = fetch('/api/library')
      .then((r) => (r.ok ? r.json() : null))
      .then((m) => (m?.clips ? new Map(m.clips.map((c) => [c.id, c])) : new Map()))
      .catch(() => new Map());
  }
  return manifestPromise;
}

export function useClipLookup() {
  const [clips, setClips] = useState(null);
  useEffect(() => {
    let cancelled = false;
    loadClips().then((m) => { if (!cancelled) setClips(m); });
    return () => { cancelled = true; };
  }, []);
  return (id, fallbackSeed = '') => {
    if (!clips) return null;
    if (id && clips.has(id)) return clips.get(id);
    const key = fallbackSeed || id;
    if (key && clips.size > 0) {
      const arr = Array.from(clips.values()).filter(c => c.peaks && c.peaks.length > 0);
      if (arr.length > 0) {
        let h = 2166136261;
        for (let i = 0; i < key.length; i++) {
          h ^= key.charCodeAt(i);
          h = Math.imul(h, 16777619);
        }
        return arr[Math.abs(h) % arr.length];
      }
    }
    return null;
  };
}

export default useClipLookup;
